import { BRYCEN_CLICKED, JILLIAN_CLICKED, WEDDING_DATE_CLICKED, COUNTDOWN_CHANGED } from '../actions/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case BRYCEN_CLICKED:
      return {
        ...state,
        brycenFace: action.brycenFace += 1
      };
    case JILLIAN_CLICKED:
      return {
        ...state,
        jillianFace: action.jillianFace += 1
      };
    case WEDDING_DATE_CLICKED:
      return {
        ...state,
        showFullDate: !action.showFullDate
      };
    case COUNTDOWN_CHANGED:
      return {
        ...state,
        countdown: action.countdown,
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/title.js